import { useTranslation } from "react-i18next";

import { AddStakeholderBasicForm } from "src/core/components/folder/stakeholders/AddStakeholderBasicForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";
import { useAddStakeholderBasicForm } from "src/core/hooks/folder/useAddStakeholderBasicForm";

type AddStakeholderModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onSuccess?: () => void;
  onCreateSuccess?: (stakeholderId: string) => void;
};

export const AddStakeholderModal = ({
  open,
  setOpen,
  onCreateSuccess,
}: AddStakeholderModalProps) => {
  const { t } = useTranslation();

  const { form, onSubmit, isLoading, roleOptions } = useAddStakeholderBasicForm({
    setOpen,
    onCreateSuccess,
  });

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="modal-add-stakeholder"
        hideCloseButton
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="modal-add-stakeholder-header">
          <DialogTitle>{t("addStakeholder.modal.title")}</DialogTitle>
          <DialogDescription className="sr-only">
            {t("addStakeholder.modal.description")}
          </DialogDescription>
        </DialogHeader>

        <AddStakeholderBasicForm
          form={form}
          onSubmit={onSubmit}
          isLoading={isLoading}
          roleOptions={roleOptions}
          setOpen={setOpen}
        />
      </DialogContent>
    </Dialog>
  );
};
